// extracted by mini-css-extract-plugin
export default {"radioLabel":"RadioFinishesColorBtn_radioLabel__0yRlZ"};